import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen.js";

// The router singleton — imported both by main.tsx (RouterProvider) and by the failure
// handler (src/lib/api/failure-handler.ts) for the 401 -> /sign-in redirect, which fires from
// outside the component tree (TanStack Query's global QueryCache/MutationCache onError).
//
// defaultPendingMs is CRAFT §2's "< 150ms expected: show nothing" rule applied to route
// transitions: a pendingComponent (when a route has one) only appears after 150ms, so fast
// navigations never flash a loading state.
export const router = createRouter({
  routeTree,
  defaultPendingMs: 150,
  defaultPreload: "intent",
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
